import { render, staticRenderFns } from "./OCProductCard.html?vue&type=template&id=362f90ce&scoped=true&"
import script from "./OCProductCard.ts?vue&type=script&lang=ts&"
export * from "./OCProductCard.ts?vue&type=script&lang=ts&"
import style0 from "./OCProductCard.css?vue&type=style&index=0&id=362f90ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362f90ce",
  null
  
)

export default component.exports